<div fxLayout="row wrap">
    <div fxFlex="100" class="flex-p"> 
        <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [mapTypeControl]="true">
            <agm-marker [latitude]="lat" [longitude]="lng" [markerDraggable]="true"></agm-marker>
        </agm-map>
    </div>
</div>